import jscookie from 'js-cookie'
import Vue from 'vue'
import { AUTH_API_COOKIE } from '../modules/user'
import { LINE_DETAIL_COOKIE } from '../modules/user'

const vm = new Vue()

const state = {

	//floors: ['B1', 'B', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],

	darkenOverlay: true,
	showCadText: true,
	globalElevatorOpen: false,
	phoneSearchOpen: null,
	phoneSidebarOpen: false,
	mainSidebarOpen: false,
	roomAssociationSidebarOpen: false,
	contentSidebarOpen: false,
	optionsSidebarOpen: false,
	dvAdminSidebarOpen: false,
	BulkRoomEditSideBarOpen: false,
	searchResultSidebarOpen: false,
	roomAmenitySidebarOpen: false,
	labelSidebarOpen: false,
	collectionSidebarOpen: false,
	buildingCardOpen: true,
	measureOpen: false, // default value of measure box open shoule be false
	legendOpen: false,
	roomCollectionAutoAdd: null,
	snack: false,
	snackText: "",

	colorPickerOpen: false,
	selectionCentering: true,      // Selected Bldg or Room will center in map if true.  Else no.
	hoverRoomNumber: null,
	currentFloor: "1",
	activeTab: "0",
	
	showBuildingLabels: true,
	darkTheme: false,
	singleBuildingMode: false,
	showBasemap: true,
	showLineDetail: true,
	showAllRoomNumbers: false,
	//showLineDetail: jscookie.get(LINE_DETAIL_COOKIE),

	clVisible : false,
	clFontSize: 8,
	clRoomNumber: true,
	clArea: false,
	clName: false,
	clPI: false,
	clOccupant: false,
	clHybrid: false,
	clNaming: "nameLast",
	clWrap: "wrap1",
	clNameBreak: false,
	clLimitY: 3,
	clLimitX: 8,
	clHalo: false,

	showTestDialog: false,
	showPhotoViewer: false,
	showPhotoUpload: false,
	showPhotoReview: false,
	showUpdateOccupancy: false,
	showHelpRoomCollections: false,
	showHelpRoomAssociation: false,
	showHelpRoomAmenities: false,
	showHelpRoomAmenities2: false,
	showHelpRoomAttributeSearch: false,
	showPermissionsEditor: false,
	showAddEmployeeToRoomDialog: false,

	mainMenuIsTemporary: true,

	stats: [],

	deptColors: [],
	categoryColors: [],
	legendColors: [],
	multiSelectRoomArray: [],

	adminSidebarOpen: false,
	useDevDatabase: false, 
	showIndicatorPhotoReview: false,

}

const mutations = {

	setMainMenuIsTemporary(state, payload) {
		state.mainMenuIsTemporary = payload
	},
	
	setDarkenOverlay(state, payload) {
		state.darkenOverlay = payload
	},
	updateMainSidebar(state, payload) {
		//console.log("updateMainSidebar", payload)
		state.mainSidebarOpen = payload
	},
	updatePhoneSearch(state, payload) {
		state.phoneSearchOpen = payload
	},
	updateShowCadText(state, payload) {
		state.showCadText = payload
	},
	updateGlobalElevator(state, payload) {
		state.globalElevatorOpen = payload
	},
	updatePhoneSidebar(state, payload) {
		state.phoneSidebarOpen = payload
		if (payload) { state.contentSidebarOpen = true }
	},
	updateRoomAssociationSidebar(state, payload) {
		state.roomAssociationSidebarOpen = payload
	},
	updateOptionsSidebar(state, payload) {
		state.optionsSidebarOpen = payload
	},
	setUseDevDatabase(state, payload) {
		state.useDevDatabase = payload
	},
	updateAdminSidebar(state, payload) {
		state.adminSidebarOpen = payload
		if (payload) { state.roomAssociationSidebarOpen = false }
	},
	updatedvAdminSidebar(state, payload) {
		state.dvAdminSidebarOpen = payload
		if (payload) { state.roomAssociationSidebarOpen = false }
	},
	updateContentSidebar(state, payload) {
		state.contentSidebarOpen = payload
		if (!payload) { state.phoneSidebarOpen = false }
	},
	updateBulkRoomEditSideBar(state, payload) {
		state.BulkRoomEditSideBarOpen = payload
	},
	updateCollectionSidebar(state, payload) {
		state.collectionSidebarOpen = payload
		if (payload == false) {
			state.roomCollectionAutoAdd = null  // Turn off auto-add when closing sidebar
		}
	},
	updateSearchResultSidebar(state, payload) {
		state.searchResultSidebarOpen = payload
	},
	updateRoomAmenitySidebarOpen(state, payload) {
		state.roomAmenitySidebarOpen = payload
	},
	updateLabelSidebar(state, payload) {
		state.labelSidebarOpen = payload
	},
	updateSelectionCentering(state, payload) {
		//console.log("SetCentering: ", payload)
		state.selectionCentering = payload
	},
	setBuildingCardOpen(state, payload) {
		state.buildingCardOpen = payload
	},
	setLegendOpen(state, payload) {
		state.legendOpen = payload
	},
	setMultiSelectRoomArray(state, payload) {
		state.multiSelectRoomArray = payload
		//console.log("MultiSelect Array", payload)
	},
	
	removeFromMultiSelectRoomArray(state, payload) {
		let deleteRoomIndex = state.multiSelectRoomArray.findIndex((room) => room === payload )
		if (deleteRoomIndex >= 0) {
			vm.$delete(state.multiSelectRoomArray, deleteRoomIndex)
		}		
	},
	clearMultiSelectRoomArray(state, payload) {
		state.multiSelectRoomArray = []
	},
	setColorPickerOpen(state, payload) {
		state.colorPickerOpen = payload
	},
	setHoverRoomNumber(state, payload) {
		state.hoverRoomNumber = payload
	},
	setCurrentFloor(state, payload) {
		state.currentFloor = payload
	},
	setShowBuildingLabels(state, payload) {
		state.showBuildingLabels = payload
	},
	setDarkTheme(state, payload) {
		state.darkTheme = payload
	},
	setActiveTab(state, payload) {
		state.activeTab = payload
	},
	setSingleBuildingMode(state, payload) {
		if (payload) { state.showLineDetail = false } 
		// We do this because the Plan layers (the ones with lines) 
		// do not have any attributes which can can filter on.  Plan lines are all on, or all off.
		// It would require us to add ROOMEXT to the plan layers during processing

		state.singleBuildingMode = payload
	},
	setShowBasemap(state, payload) {
		state.showBasemap = payload
	},
	setShowLineDetail(state, payload) {
		if (!state.singleBuildingMode) { 
			console.log("setShowLineDetail", payload)
			state.showLineDetail = payload
			//Create cookie to store line detail state. Expire in 5 years (1825 days). Replace cookie if it already exists.
			jscookie.set(LINE_DETAIL_COOKIE, payload, { expires: 1825 })
		}
	},
	setShowAllRoomNumbers(state, payload) {
		state.showAllRoomNumbers = payload
	},

	showMeasure (state, payload) {
    //console.log('Show Measure:: ' + payload)
    	state.measureOpen = payload
    	state.buildingCardOpen = false 
  	},
  	setclVisible (state, payload) {
  		state.clVisible = payload
  	},
  	setclFontSize (state, payload) {
  		state.clFontSize = payload
  	},
  	setclRoomNumber (state, payload) {
  		state.clRoomNumber = payload
  	},
  	setclArea (state, payload) {
  		state.clArea = payload
  	},
  	setclName (state, payload) {
  		state.clName = payload
  	},
  	setclPI (state, payload) {
  		state.clPI = payload
  	},
  	setclOccupant (state, payload) {
  		state.clOccupant = payload
  	},
  	setclHybrid (state, payload) {
  		state.clHybrid = payload
  	},
  	setclNaming (state, payload) {
  		state.clNaming = payload
  	},
  	setclWrap (state, payload) {
  		state.clWrap = payload
  	},
  	setclNameBreak (state, payload) {
  		state.clNameBreak = payload
  	},
  	setclHalo (state, payload) {
  		state.clHalo = payload
  	},
  	setclLimitX (state, payload) {
  		state.clLimitX = payload
  	},
  	setclLimitY (state, payload) {
  		state.clLimitY = payload
  		//console.log("---------------Mutation: setclLimitY", payload)
  	},
  	setStats (state, payload) {
  		state.stats = payload
  	},
  	setLegendColors (state, payload) {
  		state.legendColors = payload
  	},

  	setShowTestDialog (state, payload) {
  		state.showTestDialog = payload
  	},
  	setShowPhotoViewer (state, payload) {
  		state.showPhotoViewer = payload
  	},
  	setShowPhotoUpload (state, payload) {
  		state.showPhotoUpload = payload
  	},
  	setShowPhotoReview (state, payload) {
  		state.showPhotoReview = payload
  	},
  	setShowUpdateOccupancy(state, payload) {
  		state.showUpdateOccupancy = payload
  	},
  	setRoomCollectionAutoAdd(state, payload) {
    	state.roomCollectionAutoAdd = payload
  	},
  	setSnack(state, payload) {
  		state.snack = payload
  	},
	setSnackText(state, payload) {
  		state.snackText = payload
  		state.snack = true
  	},
  	setShowIndicatorPhotoReview(state, payload) {
  		state.showIndicatorPhotoReview = payload
  	},
  	setShowHelpRoomCollections(state, payload) {
  		state.showHelpRoomCollections = payload
  	},
  	setShowHelpRoomAssociation(state, payload) {
  		state.showHelpRoomAssociation = payload
  	},
  	setShowHelpRoomAmenities(state, payload) {
  		state.showHelpRoomAmenities = payload
  	},
  	setShowHelpRoomAmenities2(state, payload) {
  		state.showHelpRoomAmenities2 = payload
  	},
  	setShowHelpRoomAttributeSearch(state, payload) {
  		state.showHelpRoomAttributeSearch = payload
  	},  	
  	setShowPermissionsEditor(state, payload) {
  		state.showPermissionsEditor = payload
  	},
  	setShowAddEmployeeToRoomDialog(state, payload) {
  		state.showAddEmployeeToRoomDialog = payload
  	}
}

const getters = {
  	getLabelState : function (state) {
	//return `${state.clVisible}|${state.clFontSize}|${state.clRoomNumber}|${state.clArea}|${state.clArea}|${state.clPI}|${state.clOccupant}|${state.clNaming}|${state.clWrap}|${state.clLimitX}|${state.clLimitY}`
	return `${state.clVisible}|${state.clFontSize}|${state.clRoomNumber}|${state.clArea}|${state.clName}|${state.clPI}|${state.clOccupant}|${state.clHybrid}|${state.clNaming}|${state.clWrap}||${state.clNameBreak}${state.clHalo}`
	
	},
}


const actions = {
	addToMultiSelectRoomArray({state, rootState, commit, dispatch}, room) {
		//if(!state.multiSelectRoomArray) { state.multiSelectRoomArray = [] } // initialize

		// If this is already in here, remove it.  Otherwise Add it
		let roomIndex = state.multiSelectRoomArray.findIndex((multiRoom) => multiRoom.roomKey == room.roomKey )
		console.log("RoomIndex ", roomIndex)
		if (roomIndex != -1) {
			state.multiSelectRoomArray.splice(roomIndex, 1)
			rootState.mapFunctions.removeGraphic([room.roomKey])
			//if (state.multiSelectRoomArray.length == 0) { state.multiSelectRoomArray = null}
		} else {
			state.multiSelectRoomArray.push(room)
			room.multiSelect = true
			rootState.mapFunctions.highlightRoom(room)
		}
		  			
		// THIS WILL CLOSE contentsidebar updatecontentsidebar(false)						
		commit('updateBulkRoomEditSideBar', state.multiSelectRoomArray.length == 0 ? false : true)


		//console.log("MultiSelectArray Rooms: ", state.multiSelectRoomArray && state.multiSelectRoomArray.map((multiRoom) => multiRoom.roomKey))
	},
	
	fetchStats ({commit, getters}, payload) {
			const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			//console.log("Action: fetchStats " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/user/metrics', {      
				      headers: {
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
				            'impersonate' : getters.impersonateID,
				      },
				      method: "POST",
				      body: JSON.stringify(payload),
				  	})
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	fetchStatsDailyUnique ({commit, getters}, payload) {
			const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			//console.log("Action: fetchStats " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/user/metrics/daily', {      
				      headers: {
				      		'database' : getters.getDatabase(),
				            'apiEsriToken' : apiEsriToken,
				            'content-type': 'application/json',
				            'impersonate' : getters.impersonateID,
				      },
				      method: "POST",
				      body: JSON.stringify(payload),
				  	})
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	fetchDeptColors ({commit, rootState}, payload) {
			//console.log("Action: fetchDeptColors ")
				return new Promise((resolve, reject) => {

					//fetch('https://services.maps.arizona.edu/pdc/rest/services/Interior_SymbologyTesting/MapServer/45/legendo?f=json', {   
					fetch(rootState.restServices.serviceURL + '/Interior_SymbologyTesting/MapServer/45/legendo?f=json', {    
				      headers: {

				      },
				  	})
				      .then(response => response.json())
				      .then(data => {
				      	//var uniqueValueInfos = data.drawingInfo.renderer.uniqueValueInfos.sort();
				      	const uniqueValueInfos = data.drawingInfo.renderer.uniqueValueInfos.sort()
				      	uniqueValueInfos.map((info) => {
				      		state.deptColors.push({name: info.label, color:info.symbol.color})
				      	})
				      	//console.log(state.deptColors)
				      	resolve(state.deptColors)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	fetchCategoryColors ({commit, rootState}, payload) {
			//console.log("Action: fetchCategoryColors ")
				return new Promise((resolve, reject) => {
					//fetch('https://services.maps.arizona.edu/pdc/rest/services/Interior_SymbologyTesting/MapServer/146/legendo?f=json', {   
					fetch(rootState.restServices.serviceURL + '/Interior_SymbologyTesting/MapServer/146/legendo?f=json', {       
				      headers: {

				      },
				  	})
				      .then(response => response.json())
				      .then(data => {
				      	//var uniqueValueInfos = data.drawingInfo.renderer.uniqueValueInfos.sort();
				      	const uniqueValueInfos = data.drawingInfo.renderer.uniqueValueInfos.sort()
				      	uniqueValueInfos.map((info) => {
				      		state.categoryColors.push({name: info.label, color:info.symbol.color})
				      	})
				      	//console.log(state.categoryColors)
				      	resolve(state.categoryColors)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	getLineDetailCookie({commit}){
		let lineDetail = jscookie.get(LINE_DETAIL_COOKIE)
		if(lineDetail == 'true') {
            commit('setShowLineDetail', true)
            return true
        }
        else {
            commit('setShowLineDetail', false)
            return false
        }
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/ui.js